import { FETCH_PAGES, ADD_PAGES, EDIT_PAGES, DELETE_PAGES } from "../actionTypes";

export const fetchPages = pages => ({
    type: FETCH_PAGES,
    pages
});

export const addPages = pages => ({
    type: ADD_PAGES,
    pages
});

export const deletePages = id => ({
    type: DELETE_PAGES,
    id
});

export const editPages = pages => ({
    type: EDIT_PAGES,
    pages
});